import { ChevronLeft, ChevronRight } from "lucide-react";

interface SliderNavProps {
  /** Current slide index (0-based) */
  activeIndex: number;
  /** Total number of slides */
  total: number;
  /** Called with the new index */
  onNavigate: (index: number) => void;
  /** Show dot indicators (default true) */
  showDots?: boolean;
  /** Label for accessibility (e.g. "service", "testimonial") */
  label?: string;
}

const SliderNav = ({
  activeIndex,
  total,
  onNavigate,
  showDots = true,
  label = "slide"
}: SliderNavProps) => {
  const prev = (activeIndex - 1 + total) % total;
  const next = (activeIndex + 1) % total;

  return (
    <div className="flex items-center gap-4">
      {/* Counter */}
      <span className="font-body text-ts-xs tracking-wider tabular-nums text-stone-500">
        ({String(activeIndex + 1).padStart(2, "0")}/{String(total).padStart(2, "0")})
      </span>

      {/* Arrows */}
      <div className="flex items-center gap-1">
        <button
          aria-label={`Previous ${label}`}
          onClick={() => onNavigate(prev)}
          className="p-1.5 rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors">

          <ChevronLeft size={14} />
        </button>
        <button
          aria-label={`Next ${label}`}
          onClick={() => onNavigate(next)}
          className="p-1.5 rounded-full border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors">

          <ChevronRight size={14} />
        </button>
      </div>

      {/* Dots */}
      {showDots && total <= 12 &&
      <div className="flex items-center gap-1.5">
          {Array.from({ length: total }).map((_, i) =>
        <button
          key={i}
          onClick={() => onNavigate(i)}
          aria-label={`Go to ${label} ${i + 1}`}
          className="w-6 h-6 flex items-center justify-center">

              <span className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
          i === activeIndex ?
          "bg-foreground/60 scale-125" :
          "bg-foreground/15"}`
          } />
            </button>
        )}
        </div>
      }
    </div>);

};

export default SliderNav;